export const INITIAL_STATE = {
  data: null,
  isFetching: false,
  finish: false,
  error: false,
  message: ''
};

export const request = (state, action) => {
  return {
    ...state,
    isFetching: true,
    error: false,
    data: null,
    message: ''
  };
};

export const success = (state, action) => {
  return {
    ...state,
    data: action.data,
    finish: true,
    isFetching: false,
    error: false,
    message: 'success'
  };
};

export const failure = (state, action) => {
  return {
    ...state,
    data: null,
    finish: true,
    isFetching: false,
    error: true,
    message: action.data
  };
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SSO_FONE_REQUESTED":
      return request(state, action);
    case "SSO_FONE_SUCEEDED":
      return success(state, action);
    case "SSO_FONE_FAILED":
      return failure(state, action);
    case "RESET":
      return INITIAL_STATE;
    default:
      return state;
  }
};
